var _g, _circle, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurrentLocation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.46408 17H6.36377M11.6671 11.6967C10.2605 13.1032 9.47037 15.0109 9.47037 17C9.47037 18.9891 10.2605 20.8968 11.6671 22.3033C13.0736 23.7098 14.9812 24.5 16.9704 24.5C18.9595 24.5 20.8671 23.7098 22.2737 22.3033C23.6802 20.8968 24.4704 18.9891 24.4704 17C24.4704 15.0109 23.6802 13.1032 22.2737 11.6967C20.8671 10.2902 18.9595 9.5 16.9704 9.5C14.9812 9.5 13.0736 10.2902 11.6671 11.6967V11.6967ZM16.9704 6.3934V9.48416V6.3934ZM16.9704 24.519L16.9704 27.6066L16.9704 24.519ZM27.577 17H24.4989H27.577Z",
    stroke: "#192643",
    strokeMiterlimit: 10
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 2,
    fill: "#192643"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 17) rotate(-45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentLocation);
export default __webpack_public_path__ + "static/media/current-location.e4fc6e94136502f216a4de1e7ec72e9d.svg";
export { ForwardRef as ReactComponent };